export const copyTextToClipboard = (text: string, callback: () => void) => {
  if (!navigator.clipboard) {
    const input = document.createElement('input')
    input.style.cssText = `position: fixed; top: -999px; left: -999px;`
    input.value = text
    document.body.appendChild(input)
    input.focus()
    input.select()
    document.execCommand('copy')
    return
  }
  navigator.clipboard.writeText(text).then(() => {
    callback()
  }, console.error)
}
